/* eslint-disable import/no-cycle */
import api from './api.service';

function teacherReportBooked(params) {
  return api.get('/campaigns/report/teachers-booked', params);
}

function teacherReport(params) {
  return api.get('/campaigns/report/teachers-all', params);
}

function propagandistReportBooked(params) {
  return api.get('/campaigns/report/propagandists-booked', params);
}

function teacherReportBookedGrouped(params) {
  return api.get('/campaigns/report/propagandists-booked-grouped', params);
}

function propagandistReportBookedTotal(params) {
  return api.get('/campaigns/report/propagandists-booked-total', params);
}

function bookReportOrdered(params) {
  return api.get('/campaigns/report/books-ordered', params);
}


export const campaignsReportService = {
  teacherReportBooked,
  teacherReport,
  propagandistReportBooked,
  propagandistReportBookedTotal,
  teacherReportBookedGrouped,
  bookReportOrdered,
};
